import React, { useState, createContext, useContext, useEffect } from "react";
import userAPI from "../Api/userAPI";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [token, setToken] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let savedToken = JSON.parse(window.localStorage.getItem("token"))
    if(savedToken && savedToken != undefined) setToken(savedToken);
  }, []);

  const oauth = () => {
    setLoading(true);
    window.location =
      "https://login.wrike.com/oauth2/authorize/v4?client_id=atPjwZdB&response_type=code";
  };

  const login = (code) => {
    setLoading(true);
    return userAPI.login(code)
    .then((res) => {
      window.localStorage.setItem("token", res.access_token)
      setToken(res.access_token);
      setLoading(false);
      return Promise.resolve();
    });
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        oauth,
        login,
        token,
        loading
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
